import React, { useContext,useState,useEffect } from 'react';
import AppContext from '../Context/AppContext';
import axios from 'axios';

const ServerAll = () => {
    const [page,setPage]=useState(1)
    const {mapUrl}=useContext(AppContext)
    const init = async()=>{
        
       const response = await axios.get(mapUrl.orchestrator_videos.replace("${page}",page))
       console.log(response);
       
    }
    useEffect(() => {
        init();
    }, [])
    return (
        <div>
            
        </div>
    );
};

export default ServerAll;